import { SR_API_ACTION_CONFIRM_PHONE } from 'api/actionTypes';

export default async function confirmPhone({ state, apiClient }, { phone }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_CONFIRM_PHONE,
    state: state,
    payload: {
      phone,
    },
    onSuccess() {
      state.set(['currentUser', 'phone'], phone);
      state.set(['currentUser', 'phoneConfirmed'], true);
    },
  });
}
